import { ensureSyntaxTree } from "@codemirror/language";
const HUNDRED_MS = 100;
export const previousSiblingIs = (state, pos, expectedName) => {
    const tree = ensureSyntaxTree(state, pos, HUNDRED_MS);
    if (!tree) {
        return null;
    }
    const thisNode = tree.resolve(pos);
    const previousNode = thisNode?.prevSibling;
    return previousNode?.type.name === expectedName;
};
export const getOptionalArgumentText = (state, optionalArgumentNode) => {
    const shortArgNode = optionalArgumentNode.getChild("ShortOptionalArg");
    if (shortArgNode) {
        return state.doc.sliceString(shortArgNode.from, shortArgNode.to);
    }
};
export const nodeHasError = (node) => {
    let hasError = false;
    node.cursor().iterate(({ type }) => {
        if (hasError) return false;
        if (type.isError) {
            hasError = true;
            return false;
        }
        return true;
    });
    return hasError;
};
export const childOfNodeWithType = (node, ...types) => {
    let childOfType = null;
    node.cursor().iterate((child) => {
        if (childOfType !== null) {
            return false;
        }
        for (const type of types) {
            if (child.type.is(type)) {
                childOfType = child.node;
                return false;
            }
        }
        return true;
    });
    return childOfType;
};
